<template>
  <div class="base-combo flex agile-center">
    <el-select
        v-if="selectOptions"
        :value="value"
        v-bind="attrs"
        :style="{ width: selectWidth + 'px' }"
        class="base-combo-select select-left-none"
        @change="change"
    >
        <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
    <div class="base-combo-slot-box flex-1">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-combo',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: [String, Number, Object, Array],
    selectOptions: {
        type: Array,
        default: null,
    },
    attrs: {
        type: Object,
        default: () => ({}),
    },
    selectWidth: {
        type: Number,
        default: 120,
    },
  },
  data() {
    return {

    }
  },
  computed: {
  },
  methods: {
    change(val){
        this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-combo{
    .select-left-none{
        ::v-deep .el-input .el-input__inner{
            border-right: none;
        }
    } 
    .base-combo-slot-box{
        ::v-deep .el-input__inner{
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}
</style>